import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "identity-card" }
const _hoisted_2 = { class: "photo-section" }
const _hoisted_3 = { class: "photo-container" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "no-photo"
}
const _hoisted_6 = { class: "info-section" }
const _hoisted_7 = { class: "card-header" }
const _hoisted_8 = { class: "info-grid" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "info-item" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "info-item" }
const _hoisted_14 = { class: "info-item" }
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = { class: "info-item full-width" }
const _hoisted_17 = {
  key: 0,
  class: "emplacements-section"
}
const _hoisted_18 = { class: "emplacements-grid" }
const _hoisted_19 = { class: "emplacement-code" }
const _hoisted_20 = { class: "emplacement-type" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.usagerInfo.photo)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.usagerInfo.photo,
              alt: `Photo de ${_ctx.usagerInfo.nom} ${_ctx.usagerInfo.prenom}`,
              class: "user-photo"
            }, null, 8, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("i", { class: "fas fa-user" }, null, -1)
            ]))]))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.usagerInfo.nom) + " " + _toDisplayString(_ctx.usagerInfo.prenom), 1),
        _createElementVNode("div", {
          class: _normalizeClass(["status-badge", _ctx.usagerInfo.etatUsager === 'Non Existant' ? 'non-existent' : 'existant'])
        }, _toDisplayString(_ctx.usagerInfo.etatUsager), 3)
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _cache[1] || (_cache[1] = _createElementVNode("label", null, "NPI :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.npi || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[2] || (_cache[2] = _createElementVNode("label", null, "Matricule :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.matricule || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[3] || (_cache[3] = _createElementVNode("label", null, "Téléphone :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.tel || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_12, [
          _cache[4] || (_cache[4] = _createElementVNode("label", null, "Email :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.email || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[5] || (_cache[5] = _createElementVNode("label", null, "Date de naissance :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDate(_ctx.usagerInfo.date_naissance)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[6] || (_cache[6] = _createElementVNode("label", null, "IFU :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.ifu || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _cache[7] || (_cache[7] = _createElementVNode("label", null, "Nationalité :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.nationalite || 'Non renseigné'), 1)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _cache[8] || (_cache[8] = _createElementVNode("label", null, "Adresse :", -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.usagerInfo.adresse || 'Non renseigné'), 1)
        ])
      ]),
      (_ctx.usagerInfo.emplacements && _ctx.usagerInfo.emplacements.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _cache[9] || (_cache[9] = _createElementVNode("h4", null, "Emplacements :", -1)),
            _createElementVNode("div", _hoisted_18, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.usagerInfo.emplacements, (emplacement) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: emplacement.codeemp,
                  class: "emplacement-item"
                }, [
                  _createElementVNode("span", _hoisted_19, _toDisplayString(emplacement.codeemp), 1),
                  _createElementVNode("span", _hoisted_20, _toDisplayString(emplacement.type || 'Non spécifié'), 1)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}